import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { TLSAccountPropTypes } from '../tlsAccountSettingsPage/propTypes';
import { SlAdminAccountPropTypes } from '../slAccountsPage/propTypes';
import { AdminTaxEntryPropTypes } from '../adminTaxEntrySettingsPage/adminTaxEntry.propTypes';
import { GLAccountListPropTypes } from '../GLAccountListPage/GLAccountList.propTypes';
import { AccountMapPropTypes } from '../accountMapPage/AccountMap.propTypes';
import { GlAccountsPropTypes } from '../glJournalsPage/propTypes';

import Spinner from '../../shared/spinner.component';
import HamburgerDropdown from './hamburgerDropdown.component';
import { withPermissions, permissions } from '../../shared/authorization';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import Select from '../../shared/reactSelect/select.component';
import { adminObjects } from './constants';
import downloadXlsxFile from './downloadXlsxFile';

import {
  changeSelectedAdminObject,
  saveAdminObject,
} from './store/actions';
import {
  adminObjectSelector,
  isFetchingAdminObjectSelector,
  adminObjectToExportSelector,
} from './store/selectors';
import {
  categoriesStaticSelector,
  currentPeriodSelector,
  isLoadingCategoriesSelector,
} from '../../shared/store/selectors';
import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector } from '../../userData/store/selectors';

import { PeriodPropTypes } from '../../shared/propTypes/period';
import { fetchCategories } from '../../shared/store/actions';
import { categoryPropTypes } from '../../shared/propTypes';

const adminObjectsSelectOptions = [
  { label: adminObjects.TLS_ACCOUNTS, value: adminObjects.TLS_ACCOUNTS },
  { label: adminObjects.BSM_ACCOUNT, value: adminObjects.BSM_ACCOUNT },
  { label: adminObjects.BSM_TAX_ENTRY, value: adminObjects.BSM_TAX_ENTRY },
  { label: adminObjects.BSM_GL_ACCOUNT_LIST, value: adminObjects.BSM_GL_ACCOUNT_LIST },
  { label: adminObjects.BSM_GL_JOURNAL, value: adminObjects.BSM_GL_JOURNAL },
  { label: adminObjects.COMPANY_CODES, value: adminObjects.COMPANY_CODES },
  { label: adminObjects.TAX_RATES, value: adminObjects.TAX_RATES },
];

class TLSAccountTagsPage extends Component {
  static propTypes = {
    period: PeriodPropTypes.isRequired,
    changeSelectedAdminObject: PropTypes.func.isRequired,
    saveAdminObject: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    selectedAdminObject: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }).isRequired,
    adminObjectToExport: PropTypes.oneOfType([
      PropTypes.arrayOf(TLSAccountPropTypes),
      PropTypes.arrayOf(SlAdminAccountPropTypes),
      AdminTaxEntryPropTypes,
      GLAccountListPropTypes,
      AccountMapPropTypes,
      GlAccountsPropTypes,
    ]),
    categories: PropTypes.arrayOf(categoryPropTypes),
    isLoadingCategories: PropTypes.bool.isRequired,
    fetchCategories: PropTypes.func.isRequired,
    shouldDisplayZero: PropTypes.bool.isRequired,
    hideDecimals: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { fetchCategories, period } = this.props;
    fetchCategories(period.name);
  }

  componentDidUpdate(prevProps) {
    const { fetchCategories, period } = this.props;

    if (period !== prevProps.period) {
      fetchCategories(period.name);
    }
  }

  selectPeriod = selectedAdminObject => {
    const {
      period,
      changeSelectedAdminObject,
    } = this.props;

    changeSelectedAdminObject(selectedAdminObject, period);
  };

  fileToImportChange = event => {
    const {
      selectedAdminObject,
      saveAdminObject,
      period,
      categories,
    } = this.props;
    const sheetFile = event.target.files[0];
    saveAdminObject(selectedAdminObject, sheetFile, period.name, { categories });
  };

  exportToExcel = callback => {
    const {
      adminObjectToExport,
      selectedAdminObject,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      categories,
    } = this.props;

    if (adminObjectToExport.length) {
      downloadXlsxFile({
        adminObjectToExport,
        selectedAdminObject,
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
        context: {
          categories,
        },
      });
    }

    if (callback) {
      callback();
    }
  };

  render() {
    const { selectedAdminObject, isFetching, isLoadingCategories } = this.props;

    const isLoading = isFetching || isLoadingCategories;

    return (
      <div className="admin-import-settings-page">
        <SecondaryMenu>
          <Select
            className="select-admin-objects"
            clearable={false}
            name="adminObject"
            options={adminObjectsSelectOptions}
            onChange={this.selectPeriod}
            scrollMenuIntoView={false}
            value={selectedAdminObject}
          />
          <div className="hamburger-dropdown ml-auto text-right">
            <HamburgerDropdown
              exportToExcel={this.exportToExcel}
              fileToImportChange={this.fileToImportChange}
              isFetching={isLoading}
            />
          </div>
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <div className="d-flex flex-row justify-content-between">
                  <h5>Admin Import</h5>
                </div>
              </div>
            </div>
            <div className="row no-gutters page-content-container">
              <div className="admin-import-settings-spinner">
                {isLoading && <Spinner />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    period: currentPeriodSelector(state),
    selectedAdminObject: adminObjectSelector(state),
    adminObjectToExport: adminObjectToExportSelector(state),
    isFetching: isFetchingAdminObjectSelector(state),
    shouldDisplayZero: displayZeroSelector(state),
    hideDecimals: hideDecimalsSelector(state),
    negativeMinus: negativeMinusSelector(state),
    categories: categoriesStaticSelector(state),
    isLoadingCategories: isLoadingCategoriesSelector(state),
  };
}

export default withPermissions(permissions.ACCOUNT_TAGS)(connect(
  mapStateToProps,
  {
    changeSelectedAdminObject,
    saveAdminObject,
    fetchCategories,
  }
)(TLSAccountTagsPage));
